import { createContext, useContext } from "react";
import { Case } from "../Case.types";
import { BulkSelectability } from "./bulkRenewal.functions";

export type BulkRenewalSelection = {
    isSelected: (selectedCase: Case) => boolean;
    getSelectability: (selectedCase: Case) => BulkSelectability;
    onSelectedChanged: (selectedCase: Case, selected: boolean) => void;
};

// Rows are cached inside DotLegalTable and only re-rendered when the rows change, so selection is shared through context to reach them
export const BulkRenewalContext = createContext<BulkRenewalSelection | undefined>(undefined);

export const useBulkRenewalSelection = () => useContext(BulkRenewalContext);
